<template>
	<div>
		<van-sticky>
			<navbar :title="title" />
			<van-search v-model="search" show-action placeholder="请输入搜索关键词" @search="onSearch">
				<template #action>
					<div @click="showSelect">筛选</div>
				</template>
			</van-search>
			<div style="padding: 0 10px; background: #fff;">
				<van-tag
					closeable
					v-if="tag.date"
					size="medium"
					type="primary"
					@close="tagClose('date')"
				>{{ tagData.date }}</van-tag>
				<van-tag
					closeable
					v-if="tag.company"
					size="medium"
					type="success"
					@close="tagClose('company')"
				>{{ tagData.company.name }}</van-tag>
			</div>
		</van-sticky>

		<van-list
			v-model="list.loading"
			:finished="list.finished"
			finished-text="没有更多了"
			@load="onLoad"
			style="padding-bottom: 50px;"
		>
			<van-swipe-cell
				v-for="(item) in list.list"
				:key="item.id"
			>
			<van-cell  @click="signDetails(item.sign_id)">
				<div class="user-title">
					<span class="user-title-name" style="font-weight: 600;">
						<van-icon name="user-o" />
						{{ item.user_name }}
					</span>
					<span class="user-title-date" style="float: right;">
						{{
						item.sign_date
						}}
					</span>
				</div>
				<div>
					<van-icon name="records" />
					所属公司: {{ item.organization_name }}
				</div>
				<div>
					<van-icon name="location-o" />
					签到地址: {{ item.sign_address }}
				</div>
				<div>
					<van-icon name="records" />
					客户姓名: {{ item.client_name }}
				</div>
				<div>
					<van-icon name="location-o" />
					客户地址: {{ item.address }}
				</div>
				<div>备注: {{ item.sign_remark }}</div>
				
				<!-- <van-tag class="item-tag" plain :type="tagPrimary[item.state].value">{{
					tagPrimary[item.state].text }}</van-tag> -->
			</van-cell>
				<template #right>
					<div class="swipe-button" v-if="item.latitude != 0">
						<van-button
							class="swipe-button"
							@click="Maplication(item.latitude,item.longitude)"
							square
							type="info"
							text="地图"
						/>
					</div>
				</template>
			</van-swipe-cell>
			<!-- </van-cell> -->
		</van-list>
		<van-tabbar v-model="activeName">
			<van-tabbar-item name="sign" icon="location-o" to="/sign">签到</van-tabbar-item>
			<van-tabbar-item name="list" icon="label-o" to="/sign/list">签到记录</van-tabbar-item>
		</van-tabbar>

		<van-action-sheet
			v-model="popup.select"
			:actions="actions"
			cancel-text="取消"
			@select="onSelect"
			@cancel="onCancel"
		/>
		<van-calendar
			v-model="popup.date"
			:min-date="minDate"
			:max-date="maxDate"
			:default-date="maxDate"
			@confirm="checkDate"
		/>
		<van-popup v-model="popup.company" position="bottom">
			<van-picker
				show-toolbar
				:columns="columns"
				@cancel="popup.company = false"
				@confirm="checkCompany"
				value-key="organization_name"
			/>
		</van-popup>
		<!-- 地图弹出层 -->
			<AmapPicker 
			v-model="popup.map" 
			:draggable="false" 
			:isSearch="false"
			:isbutton="false"
			:isNavigation="false"
			:columns="mapdata"/>
	</div>
</template>

<script>
import navbar from "@/components/navBar/index";
import { signList, companyList, getImage } from "@/api/sign";
import { Toast } from "vant";
import { ImagePreview } from "vant";
import { getNowFormatDate } from "@/utils/tool";
import AmapPicker from "@/components/maps/AmapPicker.vue"; // 引入 AddressPicker 组件

export default {
	name: "signList",
	components: {
		navbar,
		AmapPicker // 注册 AddressPicker 组件
	},
	data() {
		return {
			title: "签到记录",
			activeName: "list",
			search: "",
			list: {
				list: [],
				loading: false,
				finished: false,
				page: 1,
				limit: 15,
			},
			popup: {
				select: false,
				date: false,
				company: false,
                map: false, // 地图弹窗
			},
			actions: [
				{ name: "日期筛选", value: 0 },
				{ name: "公司筛选", value: 1 },
			],
			tag: {
				date: false,
				company: false,
			},
			tagData: {
				date: "",
				company: {
					name: "",
					id: "",
				},
			},
			minDate: new Date(new Date().getFullYear() - 1, 0, 1),
			maxDate: new Date(),
			columns: [
				{ text: "杭州", id: 1 },
				{ text: "宁波", id: 2 },
				{ text: "温州", id: 3 },
			],
			imageList: [],
            map: null, // 地图实例
            marker: null, // 标记实例
            latitude: 0, // 纬度
            longitude: 0, // 经度
			mapdata: {
				latitude: 0, // 纬度
				longitude: 0, // 经度
				},
		};
	},
	mounted() {
		this.getCompanyList();
	},
	methods: {
		onLoad() {
			let axiosData = new Object();
			axiosData.requestType = "visit_sign_list_data";
			axiosData.page = this.list.page;
			axiosData.limit = this.list.limit;
			axiosData.search = this.search;
			axiosData.organization_id = this.tagData.company.id;
			axiosData.search_for_date = this.tagData.date;

			signList(axiosData)
				.then((response) => {
					if (response.obj.rows.length === 0) {
						this.list.finished = true;
					}
					if (this.list.page != 1) {
						this.list.list = this.list.list.concat(
							response.obj.rows
						);
					} else {
						this.list.list = response.obj.rows;
					}

					this.list.page += 1;
					this.list.loading = false;
				})
				.catch((err) => {
					console.log(err);
					this.list.loading = false;
					this.list.finished = true;
					return Toast.fail("网络连接错误,请求超时,请稍后重试!");
				});
		},
		onSearch() {
			this.list.page = 0;
			this.list.list = [];
			this.onLoad();
		},
		showSelect() {
			this.popup.select = true;
		},
		onSelect(item) {
			if (item.value === 0) {
				this.popup.date = true;
			}

			if (item.value === 1) {
				this.popup.company = true;
			}
			this.popup.select = false;
		},
		onCancel() {
			this.popup.select = false;
		},
		checkDate(date) {
			this.popup.date = false;
			this.setTag(getNowFormatDate(date), "date");
		},
		checkCompany(picker) {
			this.popup.company = false;
			this.setTag(picker, "company");
		},
		setTag(data, type) {
			if (type == "date") {
				this.tagData.date = data;
			}
			if (type == "company") {
				this.tagData.company.name = data.organization_name;
				this.tagData.company.id = data.organization_id;
			}
			this.list.page = 0;
			this.list.list = [];
			this.onLoad();
			this.tag[type] = true;
		},
		tagClose(type) {
			if (type == "date") {
				this.tagData.date = "";
			}
			if (type == "company") {
				this.tagData.company.name = "";
				this.tagData.company.id = "";
			}
			this.list.page = 0;
			this.onLoad();
			this.tag[type] = false;
		},
		signDetails(id) {
			this.imageList = [];
			getImage({ requestType: "visit_file_list", sign_id: id })
				.then((response) => {
					if (response.obj.length === 0) {
						return Toast("无附件图片");
					}
					response.obj.forEach((item) => {
						this.imageList.push(this.GLOBAL.fileUrl + item.file_id);
					});
					ImagePreview(this.imageList);
				})
				.catch((err) => {
					console.log(err);
					return Toast("数据异常");
				});
			// this.$router.push("/signIn/details");
		},
		getCompanyList() {
			companyList({ requestType: "organization_list" })
				.then((response) => {
					this.columns = response.obj;
				})
				.catch((err) => {
					console.log(err);
					return Toast("数据异常");
				});
		},
        Maplication(latitude, longitude) {
            this.mapdata.latitude = latitude;
            this.mapdata.longitude = longitude;
            this.popup.map = true;
            // this.$nextTick(() => {
            //     this.initMap(latitude, longitude);
            // });
        },
        // initMap(latitude, longitude) {
		// 	let AMap = window.AMap;
        //     if (!window.AMap) {
        //         console.error("高德地图 SDK 未加载");
        //         return;
        //     }

        //     // 创建地图实例
        //     this.map = new AMap.Map('mapContainer', {
        //         zoom: 16, // 缩放级别
        //         center: [longitude, latitude] // 地图中心点
        //     });

        //     // 创建标记
        //     this.marker = new AMap.Marker({
        //         position: new AMap.LngLat(longitude, latitude), // 标记位置
        //         title: '签到位置' // 标记标题
        //     });

        //     // 将标记添加到地图
        //     this.map.add(this.marker);
        // },
        // startNavigation() {
        //     if (!this.latitude || !this.longitude) {
        //         return Toast.fail("位置信息不完整");
        //     }

        //     // 使用高德地图导航
        //     const url = `https://uri.amap.com/marker?position=${this.longitude},${this.latitude}&name=签到位置&src=mypage&coordinate=gaode&callnative=0`;
        //     window.location.href = url;
        // }
	},
};
</script>

<style>
.van-tag + .van-tag {
	margin-left: 8px;
}
.swipe-button {
	height: 100%;
}
</style>
